export default "__VITE_ASSET__3c1e9057__$_?nuxt_component=async__"